module.exports = __webpack_public_path__ + "img/20190611_173512_079.13ecad34.jpg";